module.exports = __webpack_public_path__ + "img/s03_p01.6c35bf1a.png";